import { SidebarAdsDocument, SidebarAdsQuery } from '@/generated/graphql'
import { graphqlRequest } from '@/lib/serverSideClient'
import Link from 'next/link'
import { ProgressiveImage } from '@/ProgressiveImage'
import { getRandomAd, normalizeSidebarAdImageSrc } from './helpers'

export const SidebarAd = async () => {
  async function getSidebarAds(): Promise<SidebarAdsQuery['sidebarAds']> {
    try {
      const data = await graphqlRequest<SidebarAdsQuery>(SidebarAdsDocument, {
        brandCode: 'VANISHING_INC_US',
      })

      if (!data?.sidebarAds?.items?.length) {
        return null
      }

      return data.sidebarAds
    } catch (error) {
      console.error('Error fetching sidebar ads:', error)
      return null
    }
  }

  const sidebarAds = await getSidebarAds()

  if (!sidebarAds?.items?.length) {
    return null // Don't render anything if no ads
  }

  const ad = getRandomAd(
    sidebarAds.items?.map(item => ({
      imageSrc: normalizeSidebarAdImageSrc(item.imageSrc || ''),
      name: item.name || '',
      url: item.url || '',
    })) || []
  )

  if (!ad) {
    return null
  }

  return (
    <Link href={ad.url || '#'} prefetch={false}>
      <div className="aspect-[13/17] w-full xl:w-[320px] xl:h-[400px]">
        <ProgressiveImage
          imageUrl={ad.imageSrc || ''}
          alt={ad.name || ''}
          className="w-full h-full rounded-md"
        />
      </div>
    </Link>
  )
}
